// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/icons/x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/icons/instagram-logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/icons/tiktok-logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/icons/facebook-logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container Styles */
.admin-main-container {
    margin-left: 280px;
    padding: 20px;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    gap: 20px;
    width: calc(100% - 332px);
    height: 90%;
    border-radius: 10px;
    /* overflow-x: hidden; */
    /* overflow-y: auto;  */
    z-index: 1;
    margin-top: 10px;
   
  
}

/* Floating Logo Animations and Styling */
@keyframes floatLeftToRight {
    0% {
        transform: translateX(-100%);
    }
    50% {
        transform: translateX(50%);
    }
    100% {
        transform: translateX(100%);
    }
}

/* General Container Styling */
.left-side-container {
  padding: 20px;
  background-color: #ffffff;
  max-width: 1200px;
  margin: 0 auto;
  height: 75vh;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease-in-out;
  padding-top: 0px;
}

/* .left-side-container:hover {
  transform: scale(1.03);
} */

/* Admin Logs Section */
.admin-logs h3 {

  font-weight: bold;
  color: #34495e;
  margin-bottom: 10px;
  border-bottom: 3px solid #3498db;

}

/* Search Input */
.search-input {
  padding: 10px 12px;
  width: 100%;
  max-width: 350px;
  border: 2px solid #3498db;
  border-radius: 8px;
  font-size: 14px;
  color: #34495e;
  outline: none;
  transition: all 0.3s ease;
  margin-bottom: 18px;
}

.search-input:focus {
  border-color: #65ccb7;
  box-shadow: 0 0 6px rgba(101, 204, 183, 0.5);
}

/* Buttons */
.fetch-logs-button,
.download-button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  margin-bottom: 18px;
  margin-left: 20px;
}

.fetch-logs-button:disabled,
.download-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.fetch-logs-button:hover:not(:disabled),
.download-button:hover:not(:disabled) {
  background-color: #2980b9;
  transform: translateY(-2px);
}

/* Logs Table Container */
.logs-table-container {
  max-height: 45vh;
  overflow-y: auto;
  padding: 15px;
  border-radius: 8px;
  background-color: #ecf0f1;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  margin-top: 15px;
}

/* Table Styling */
.logs-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.logs-table th,
.logs-table td {
  padding: 12px;
  text-align: left;
  font-size: 14px;
  border: 1px solid #ddd;
  color: #34495e;
}

.logs-table th {
  background-color: #3498db;
  color: white;
  font-weight: 600;
  text-transform: uppercase;
}

.logs-table tr:hover {
  background-color: #f1f1f1;
  transform: scale(1.01);
  transition: all 0.3s ease;
}

.logs-table td {
  background-color: #ffffff;
  border-bottom: 1px solid #ddd;
}

/* No Logs Available Message */
.logs-table td[colspan="6"] {
  text-align: center;
  color: #888;
  font-style: italic;
}

/* Pagination Controls */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
}

.pagination button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 10px 18px;
  font-size: 14px;
  margin: 0 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination button:hover:not(:disabled) {
  background-color: #2980b9;
  transform: translateY(-2px);
}

/* Responsive Table */
@media (max-width: 768px) {
  .logs-table th,
  .logs-table td {
    padding: 10px;
    font-size: 13px;
  }

  .logs-table-container {
    max-height: 400px;
  }

  .search-input {
    max-width: 100%;
  }

  .pagination {
    flex-direction: column;
    padding: 10px;
  }
}

/* Right-Side Container */
.right-side-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
  width: 50%;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  height: 70vh; /* Adjusted to match logs container */
  transition: all 0.3s ease-in-out;
}


  
  .right-side-container:hover {
    transform: scale(1.02); /* Slight scale effect on hover */
  }
  
  /* Platform Selection */
  .mentions-platform-selection {
    display: flex;
    justify-content: space-between; /* Space between each platform */
    width: 100%;
    margin-bottom: 15px;
  }
  
  .mentions-platform-checkbox {
    display: flex;
    align-items: center;
    margin-right: 15px; /* Spacing between checkboxes */
  }
  
  .mentions-platform-checkbox input {
    margin-right: 10px;
  }
  
  .mentions-platform-checkbox label {
    font-size: 14px;
    font-weight: 400;
    color: #666;
    cursor: pointer;
  }
  
  .mentions-platform-checkbox input:checked + label {
    color: #17a2b8; /* Highlighted color when checked */
  }
  
  /* Date Filters */
  .date-filters {
    display: flex;
  
    width: 100%;
  }
  
  .date-filters label {
    font-weight: 600;
    color: #333;
    font-size: 14px;
  }
  
  .date-filters input {
    padding: 10px;
    border-radius: 10px;

    width: 150px;
    font-size: 14px;
    transition: border-color 0.3s ease;
  }
  
  .date-filters input:focus {
    border-color: #17a2b8; /* Highlighted border on focus */
    outline: none;
  }
  
  /* Coin Selector */
  .coin-selector {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  
  .coin-selector label {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #333;
  }
  
  .coin-selector select {
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #ccc;
    font-size: 14px;
    color: #666;
    width: 100%;
    transition: all 0.3s ease;
  }
  
  .coin-selector select:focus {
    border-color: #17a2b8; /* Highlighted border on focus */
    outline: none;
  }
  
  /* Mentions Action Container */
  .mentions-action-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 10px;
  }
  
 
  
  .mentions-coin {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
    animation: coin-spin 2s linear infinite;
  }
  
  @keyframes coin-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  /* Show Mentions Button */
  .show-mentions-btn {
    background-color: #17a2b8;
    color: white;
    width: 80%;
    padding: 12px;
    border-radius: 10px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
  }
  
  .show-mentions-btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  .show-mentions-btn:hover:not(:disabled) {
    background-color: #138496;
    transform: translateY(-2px); /* Slight hover effect */
  }
/* Bar Chart Container */
/* .bar-chart-container {
    width: 85%;
    height: 400px; /* Adjust the height as needed */
    /* background-color:  */
    /* border-radius: 10px; */
    /* border: 1px solid  */
    /* display: flex; */
    /* align-items: center; */
    /* justify-content: center; */
    /* flex-direction: column; */
    /* margin-right: 280px; */
 */ 


.bar-chart-title {
  font-size: 22px;
  font-weight: bold;
  /* text-align: center; */
  margin-bottom: 10px;
  
}

.bar-chart-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 82.5%;
  margin-left: 280px;
  /* max-width: 1200px; */
  display: flex;
  justify-content: center;
  margin-top: 20px;
  height: 545px;
}
.bar-chart-container.canvas {
    width: 100% !important; /* Ensure the chart fills the container */
    height: 100% !important;
}

.bar-chart-container.full-screen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: white;
    z-index: 1000;
}

.full-screen-toggle {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
}

.full-screen-toggle:focus {
    outline: none;
}



.platform-dropdown-right, .date-filter {
    width: 100%;
    padding: 8px;
    border-radius: 10px;
    border: 1px solid #ccc;
}

/* Input Field for Date Parameters */
#value-filter-parameter {
    padding: 8px;
    border-radius: 10px;
    border: 1px solid #ccc;
}

#date-filter {
    padding: 8px;
    border-radius: 10px;
    border: 1px solid #ccc;
    width: 100%;
}

/* Platform Row */
.platform-row {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
    background-color: #ffffff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Twitter Row */
.twitter-row {
    position: relative;
    background: linear-gradient(to right, #000000, #333333);
    color: white;
    padding: 20px;
    border-radius: 10px;
    overflow: hidden;
    width: 97%;
    height: auto; /* Adjusted height */
}

/* Instagram Row */
.instagram-row {
    position: relative;
    background: linear-gradient(to right, #f58529, #dd2a7b, #8134af, #515bd4);
    color: white;
    padding: 20px;
    border-radius: 10px;
    overflow: hidden;
    width: 97%;
    height: auto; /* Adjusted height */
}

/* TikTok Row */
.tiktok-row {
    position: relative;
    background: linear-gradient(45deg, #9300c7, #69c9d0); /* TikTok gradient */
    color: white;
    padding: 20px;
    border-radius: 10px;
    overflow: hidden;
    width: 97%;
    height: auto; /* Adjusted height */
}

/* Facebook Row */
.facebook-row {
    position: relative;
    background: linear-gradient(to right, #4267B2, #23395d);
    color: white;
    padding: 20px;
    border-radius: 10px;
    overflow: hidden;
    width: 97%;
    height: auto; /* Adjusted height */
}

/* Dynamic Floating Logos */
.twitter-logo,
.instagram-logo,
.tiktok-logo,
.facebook-logo {
    position: absolute;
    width: 30px;
    height: 30px;
    background-size: contain;
    background-repeat: no-repeat;
    animation: floatLeftToRight 8s linear infinite;
    opacity: 0.8;
    top: calc(10% + (80% * var(--random-y)));
}

/* Platform-Specific Logos */
.twitter-logo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.instagram-logo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.tiktok-logo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.facebook-logo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

/* Optional: Glowing Effect */
.twitter-logo.glowing,
.instagram-logo.glowing,
.tiktok-logo.glowing,
.facebook-logo.glowing {
    animation: floatLeftToRight 10s linear infinite, glow 2s infinite alternate;
}

/* Glow Animation */
@keyframes glow {
    0% {
        opacity: 0.6;
    }
    100% {
        opacity: 1;
    }
}

/* Platform Heading */
.platform-heading {
    position: absolute;
    top: 5px;
    left: 20px;
    font-size: 20px;
    font-weight: bold;
    color: white;
}

/* Filters Layout */
.filters {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
    margin-top: 10px;
}

/* Action Buttons */
.action-buttons {
    display: flex;
    gap: 10px;
}

.btn {
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 14px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s, opacity 0.3s;
}

.get-btn {
    background-color: #28a745;
    color: white;
}

.post-btn {
    background-color: #007bff;
    color: white;
}

.btn:hover {
    opacity: 0.9;
}

.btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}



/* Right-Side Platform Selection */
.mention-platform-selection {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .mention-platform-checkbox {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  
  .short-input {
    width: 120px; /* Shortened date input width */
  }
  

  /* ANIMATIONS FOR COIN */
  /* Mentions Action (Button + Coin) */
.mentions-action-container {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
}

/* Coin Container */
.mentions-coin-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* Coin Animation */
/* Mentions Action (Button + Coin) */
.mentions-action-container {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
}

/* Coin Container */
.mentions-coin-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* Coin Animation */
.mentions-coin {
    width: 40px;
    height: 40px;
    display: none;
}

/* Mentions Count */
/* .mentions-count {
    font-size: 1.2rem;
    font-weight: bold;
    color: gold;
    text-shadow: 1px 1px 3px black;
} */

/* Coin Type Selector */
.coin-selector {
    margin-top: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.coin-selector label {
    font-size: 1rem;
    font-weight: bold;
}

.coin-selector select {
    padding: 5px;
    font-size: 1rem;
    border-radius: 5px;
}
.mention-chart {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;  /* Ensures it takes full available width */
  height: 400px; /* Increase height to prevent cut-off */
  overflow: hidden;
  margin-bottom: -35px;
}

.daily-mentions-container {
  width: 90%; /* Use more space for the bar chart */
  margin: auto; /* Center it */
  display: flex;
  justify-content: center;
  align-items: center;
}

.apexcharts-canvas {
  max-width: 100% !important; /* Ensures charts resize properly */
  height: auto !important;
  margin-top: 60px
}
/* Mentions Action (Button + Coin Animation) */
.mentions-action-container {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 15px;
  }
  
  /* Mentions Counter */
  .mentions-counter {
    display: inline-flex;  /* Ensures it stays in a single line */
    align-items: center;  /* Aligns text and any icons */
    justify-content: center; /* Centers the text */
    white-space: nowrap;  /* Prevents wrapping to the next line */
    font-size: 20px;
    font-weight: 600;
    color: #1E3A8A; /* Deep blue text for a more elegant, professional feel */
    text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3); /* Softer shadow for readability */
    background-color: #F3F4F6; /* Light gray background for a clean, modern look */
    border-radius: 10px; /* Rounded corners for a smooth look */
    padding: 8px 16px; /* Padding for balance and ease */
    border: 2px solid #F3F4F6; /* Border that matches the background for subtlety */
    transition: all 0.3s ease; /* Smooth transition on hover */
}



  /* Coin Animation */
  .mentions-coin {
    width: 40px;
    height: 40px;
    animation: none; /* Initially no animation */
    display: inline-block; /* Always visible */
    margin-left: 8px;
  }
  
  /* Add animation when triggered */
  .mentions-coin.animate {
    animation: coin-spin 1s ease-in-out infinite;
  }
  
  @keyframes coin-spin {
    0% {
      transform: rotateY(0deg) scale(1);
    }
    50% {
      transform: rotateY(180deg) scale(1.2);
    }
    100% {
      transform: rotateY(360deg) scale(1);
    }
  }


  .admin-panel-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh; /* Set full-page height */
    overflow-y: auto; /* Enable scrolling for the whole page */
}





  .mentions-more-container {
    width: 82.5%; /* Slightly increase width */
    margin-left: 280px;
    padding: 20px;
    margin-top: 30px; /* More spacing from above */
    background-color: #f8f9fa;
    border-radius: 12px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
    text-align: center;
    height: 40vh; /* Increase height */
    display: flex;
    justify-content: center;
    align-items: center;
}


.bar-chart-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 20px;
}


.formatted-date {
  font-size: 16px;
  font-weight: bold;
  color: #333; /* Change color as needed */
  margin-left: 10px;
  margin-top: 11px;
  /* Add any other styling you need */
}
`, "",{"version":3,"sources":["webpack://./src/admin panel/adminmaincontainer.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;;;AAGpB;;AAEA,yCAAyC;AACzC;IACI;QACI,4BAA4B;IAChC;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH,uBAAuB;AACvB;;EAEE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;;AAElC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,YAAY;AACZ;;EAEE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,2DAA2D;EAC3D,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE;;IAEE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,YAAY,EAAE,qCAAqC;EACnD,gCAAgC;AAClC;;;;EAIE;IACE,sBAAsB,EAAE,iCAAiC;EAC3D;;EAEA,uBAAuB;EACvB;IACE,aAAa;IACb,8BAA8B,EAAE,gCAAgC;IAChE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB,EAAE,+BAA+B;EACrD;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc,EAAE,mCAAmC;EACrD;;EAEA,iBAAiB;EACjB;IACE,aAAa;;IAEb,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;;IAEnB,YAAY;IACZ,eAAe;IACf,kCAAkC;EACpC;;EAEA;IACE,qBAAqB,EAAE,gCAAgC;IACvD,aAAa;EACf;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB,EAAE,gCAAgC;IACvD,aAAa;EACf;;EAEA,8BAA8B;EAC9B;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,SAAS;EACX;;;;EAIA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,uCAAuC;EACzC;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA,yBAAyB;EACzB;IACE,yBAAyB;IACzB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2DAA2D;EAC7D;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B,EAAE,wBAAwB;EACvD;AACF,wBAAwB;AACxB;;mDAEmD;IAC/C,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;CAC5B;;;;EAIC,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;;AAErB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;AACA;IACI,sBAAsB,EAAE,yCAAyC;IACjE,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;;;AAIA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,oCAAoC;AACpC;IACI,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,uDAAuD;IACvD,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,YAAY,EAAE,oBAAoB;AACtC;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,yEAAyE;IACzE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,YAAY,EAAE,oBAAoB;AACtC;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,oDAAoD,EAAE,oBAAoB;IAC1E,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,YAAY,EAAE,oBAAoB;AACtC;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,uDAAuD;IACvD,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,YAAY,EAAE,oBAAoB;AACtC;;AAEA,2BAA2B;AAC3B;;;;IAII,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,8CAA8C;IAC9C,YAAY;IACZ,wCAAwC;AAC5C;;AAEA,4BAA4B;AAC5B;IACI,yDAA4C;AAChD;AACA;IACI,yDAAyD;AAC7D;AACA;IACI,yDAAsD;AAC1D;AACA;IACI,yDAAwD;AAC5D;;AAEA,6BAA6B;AAC7B;;;;IAII,2EAA2E;AAC/E;;AAEA,mBAAmB;AACnB;IACI;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;AACJ;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;;;AAIA,kCAAkC;AAClC;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,YAAY,EAAE,+BAA+B;EAC/C;;;EAGA,wBAAwB;EACxB,oCAAoC;AACtC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,mBAAmB;AACnB,oCAAoC;AACpC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA,mBAAmB;AACnB;;;;;GAKG;;AAEH,uBAAuB;AACvB;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW,GAAG,0CAA0C;EACxD,aAAa,EAAE,uCAAuC;EACtD,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,UAAU,EAAE,qCAAqC;EACjD,YAAY,EAAE,cAAc;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B,EAAE,mCAAmC;EAC/D,uBAAuB;EACvB;AACF;AACA,8CAA8C;AAC9C;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;EAClB;;EAEA,qBAAqB;EACrB;IACE,oBAAoB,GAAG,sCAAsC;IAC7D,mBAAmB,GAAG,8BAA8B;IACpD,uBAAuB,EAAE,qBAAqB;IAC9C,mBAAmB,GAAG,uCAAuC;IAC7D,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,yDAAyD;IACzE,2CAA2C,EAAE,kCAAkC;IAC/E,yBAAyB,EAAE,mDAAmD;IAC9E,mBAAmB,EAAE,sCAAsC;IAC3D,iBAAiB,EAAE,iCAAiC;IACpD,yBAAyB,EAAE,oDAAoD;IAC/E,yBAAyB,EAAE,+BAA+B;AAC9D;;;;EAIE,mBAAmB;EACnB;IACE,WAAW;IACX,YAAY;IACZ,eAAe,EAAE,2BAA2B;IAC5C,qBAAqB,EAAE,mBAAmB;IAC1C,gBAAgB;EAClB;;EAEA,iCAAiC;EACjC;IACE,4CAA4C;EAC9C;;EAEA;IACE;MACE,iCAAiC;IACnC;IACA;MACE,qCAAqC;IACvC;IACA;MACE,mCAAmC;IACrC;EACF;;;EAGA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa,EAAE,yBAAyB;IACxC,gBAAgB,EAAE,wCAAwC;AAC9D;;;;;;EAME;IACE,YAAY,EAAE,4BAA4B;IAC1C,kBAAkB;IAClB,aAAa;IACb,gBAAgB,EAAE,4BAA4B;IAC9C,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,YAAY,EAAE,oBAAoB;IAClC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW,EAAE,2BAA2B;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC","sourcesContent":["/* Main Container Styles */\r\n.admin-main-container {\r\n    margin-left: 280px;\r\n    padding: 20px;\r\n    background-color: #ffffff;\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 20px;\r\n    width: calc(100% - 332px);\r\n    height: 90%;\r\n    border-radius: 10px;\r\n    /* overflow-x: hidden; */\r\n    /* overflow-y: auto;  */\r\n    z-index: 1;\r\n    margin-top: 10px;\r\n   \r\n  \r\n}\r\n\r\n/* Floating Logo Animations and Styling */\r\n@keyframes floatLeftToRight {\r\n    0% {\r\n        transform: translateX(-100%);\r\n    }\r\n    50% {\r\n        transform: translateX(50%);\r\n    }\r\n    100% {\r\n        transform: translateX(100%);\r\n    }\r\n}\r\n\r\n/* General Container Styling */\r\n.left-side-container {\r\n  padding: 20px;\r\n  background-color: #ffffff;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  height: 75vh;\r\n  border-radius: 12px;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\r\n  overflow: hidden;\r\n  transition: transform 0.3s ease-in-out;\r\n  padding-top: 0px;\r\n}\r\n\r\n/* .left-side-container:hover {\r\n  transform: scale(1.03);\r\n} */\r\n\r\n/* Admin Logs Section */\r\n.admin-logs h3 {\r\n\r\n  font-weight: bold;\r\n  color: #34495e;\r\n  margin-bottom: 10px;\r\n  border-bottom: 3px solid #3498db;\r\n\r\n}\r\n\r\n/* Search Input */\r\n.search-input {\r\n  padding: 10px 12px;\r\n  width: 100%;\r\n  max-width: 350px;\r\n  border: 2px solid #3498db;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  color: #34495e;\r\n  outline: none;\r\n  transition: all 0.3s ease;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.search-input:focus {\r\n  border-color: #65ccb7;\r\n  box-shadow: 0 0 6px rgba(101, 204, 183, 0.5);\r\n}\r\n\r\n/* Buttons */\r\n.fetch-logs-button,\r\n.download-button {\r\n  background-color: #3498db;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  font-size: 14px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, transform 0.2s ease;\r\n  margin-bottom: 18px;\r\n  margin-left: 20px;\r\n}\r\n\r\n.fetch-logs-button:disabled,\r\n.download-button:disabled {\r\n  background-color: #ccc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.fetch-logs-button:hover:not(:disabled),\r\n.download-button:hover:not(:disabled) {\r\n  background-color: #2980b9;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n/* Logs Table Container */\r\n.logs-table-container {\r\n  max-height: 45vh;\r\n  overflow-y: auto;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  background-color: #ecf0f1;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\r\n  margin-top: 15px;\r\n}\r\n\r\n/* Table Styling */\r\n.logs-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 10px;\r\n}\r\n\r\n.logs-table th,\r\n.logs-table td {\r\n  padding: 12px;\r\n  text-align: left;\r\n  font-size: 14px;\r\n  border: 1px solid #ddd;\r\n  color: #34495e;\r\n}\r\n\r\n.logs-table th {\r\n  background-color: #3498db;\r\n  color: white;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.logs-table tr:hover {\r\n  background-color: #f1f1f1;\r\n  transform: scale(1.01);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.logs-table td {\r\n  background-color: #ffffff;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n/* No Logs Available Message */\r\n.logs-table td[colspan=\"6\"] {\r\n  text-align: center;\r\n  color: #888;\r\n  font-style: italic;\r\n}\r\n\r\n/* Pagination Controls */\r\n.pagination {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 12px;\r\n}\r\n\r\n.pagination button {\r\n  background-color: #3498db;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 18px;\r\n  font-size: 14px;\r\n  margin: 0 8px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, transform 0.2s ease;\r\n}\r\n\r\n.pagination button:disabled {\r\n  background-color: #ccc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.pagination button:hover:not(:disabled) {\r\n  background-color: #2980b9;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n/* Responsive Table */\r\n@media (max-width: 768px) {\r\n  .logs-table th,\r\n  .logs-table td {\r\n    padding: 10px;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .logs-table-container {\r\n    max-height: 400px;\r\n  }\r\n\r\n  .search-input {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .pagination {\r\n    flex-direction: column;\r\n    padding: 10px;\r\n  }\r\n}\r\n\r\n/* Right-Side Container */\r\n.right-side-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  gap: 20px;\r\n  width: 50%;\r\n  padding: 20px;\r\n  background-color: #f8f9fa;\r\n  border-radius: 12px;\r\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);\r\n  height: 70vh; /* Adjusted to match logs container */\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\n\r\n  \r\n  .right-side-container:hover {\r\n    transform: scale(1.02); /* Slight scale effect on hover */\r\n  }\r\n  \r\n  /* Platform Selection */\r\n  .mentions-platform-selection {\r\n    display: flex;\r\n    justify-content: space-between; /* Space between each platform */\r\n    width: 100%;\r\n    margin-bottom: 15px;\r\n  }\r\n  \r\n  .mentions-platform-checkbox {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-right: 15px; /* Spacing between checkboxes */\r\n  }\r\n  \r\n  .mentions-platform-checkbox input {\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  .mentions-platform-checkbox label {\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    color: #666;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .mentions-platform-checkbox input:checked + label {\r\n    color: #17a2b8; /* Highlighted color when checked */\r\n  }\r\n  \r\n  /* Date Filters */\r\n  .date-filters {\r\n    display: flex;\r\n  \r\n    width: 100%;\r\n  }\r\n  \r\n  .date-filters label {\r\n    font-weight: 600;\r\n    color: #333;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .date-filters input {\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n\r\n    width: 150px;\r\n    font-size: 14px;\r\n    transition: border-color 0.3s ease;\r\n  }\r\n  \r\n  .date-filters input:focus {\r\n    border-color: #17a2b8; /* Highlighted border on focus */\r\n    outline: none;\r\n  }\r\n  \r\n  /* Coin Selector */\r\n  .coin-selector {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n  \r\n  .coin-selector label {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    margin-bottom: 10px;\r\n    color: #333;\r\n  }\r\n  \r\n  .coin-selector select {\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    border: 1px solid #ccc;\r\n    font-size: 14px;\r\n    color: #666;\r\n    width: 100%;\r\n    transition: all 0.3s ease;\r\n  }\r\n  \r\n  .coin-selector select:focus {\r\n    border-color: #17a2b8; /* Highlighted border on focus */\r\n    outline: none;\r\n  }\r\n  \r\n  /* Mentions Action Container */\r\n  .mentions-action-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n    gap: 10px;\r\n  }\r\n  \r\n \r\n  \r\n  .mentions-coin {\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 50%;\r\n    object-fit: cover;\r\n    animation: coin-spin 2s linear infinite;\r\n  }\r\n  \r\n  @keyframes coin-spin {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n  \r\n  /* Show Mentions Button */\r\n  .show-mentions-btn {\r\n    background-color: #17a2b8;\r\n    color: white;\r\n    width: 80%;\r\n    padding: 12px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease, transform 0.2s ease;\r\n  }\r\n  \r\n  .show-mentions-btn:disabled {\r\n    background-color: #ccc;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  .show-mentions-btn:hover:not(:disabled) {\r\n    background-color: #138496;\r\n    transform: translateY(-2px); /* Slight hover effect */\r\n  }\r\n/* Bar Chart Container */\r\n/* .bar-chart-container {\r\n    width: 85%;\r\n    height: 400px; /* Adjust the height as needed */\r\n    /* background-color:  */\r\n    /* border-radius: 10px; */\r\n    /* border: 1px solid  */\r\n    /* display: flex; */\r\n    /* align-items: center; */\r\n    /* justify-content: center; */\r\n    /* flex-direction: column; */\r\n    /* margin-right: 280px; */\r\n */ \r\n\r\n\r\n.bar-chart-title {\r\n  font-size: 22px;\r\n  font-weight: bold;\r\n  /* text-align: center; */\r\n  margin-bottom: 10px;\r\n  \r\n}\r\n\r\n.bar-chart-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\r\n  padding: 20px;\r\n  width: 82.5%;\r\n  margin-left: 280px;\r\n  /* max-width: 1200px; */\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 20px;\r\n  height: 545px;\r\n}\r\n.bar-chart-container.canvas {\r\n    width: 100% !important; /* Ensure the chart fills the container */\r\n    height: 100% !important;\r\n}\r\n\r\n.bar-chart-container.full-screen {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background-color: white;\r\n    z-index: 1000;\r\n}\r\n\r\n.full-screen-toggle {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.5rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.full-screen-toggle:focus {\r\n    outline: none;\r\n}\r\n\r\n\r\n\r\n.platform-dropdown-right, .date-filter {\r\n    width: 100%;\r\n    padding: 8px;\r\n    border-radius: 10px;\r\n    border: 1px solid #ccc;\r\n}\r\n\r\n/* Input Field for Date Parameters */\r\n#value-filter-parameter {\r\n    padding: 8px;\r\n    border-radius: 10px;\r\n    border: 1px solid #ccc;\r\n}\r\n\r\n#date-filter {\r\n    padding: 8px;\r\n    border-radius: 10px;\r\n    border: 1px solid #ccc;\r\n    width: 100%;\r\n}\r\n\r\n/* Platform Row */\r\n.platform-row {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    padding: 20px;\r\n    background-color: #ffffff;\r\n    border: 1px solid #ddd;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Twitter Row */\r\n.twitter-row {\r\n    position: relative;\r\n    background: linear-gradient(to right, #000000, #333333);\r\n    color: white;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    width: 97%;\r\n    height: auto; /* Adjusted height */\r\n}\r\n\r\n/* Instagram Row */\r\n.instagram-row {\r\n    position: relative;\r\n    background: linear-gradient(to right, #f58529, #dd2a7b, #8134af, #515bd4);\r\n    color: white;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    width: 97%;\r\n    height: auto; /* Adjusted height */\r\n}\r\n\r\n/* TikTok Row */\r\n.tiktok-row {\r\n    position: relative;\r\n    background: linear-gradient(45deg, #9300c7, #69c9d0); /* TikTok gradient */\r\n    color: white;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    width: 97%;\r\n    height: auto; /* Adjusted height */\r\n}\r\n\r\n/* Facebook Row */\r\n.facebook-row {\r\n    position: relative;\r\n    background: linear-gradient(to right, #4267B2, #23395d);\r\n    color: white;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    width: 97%;\r\n    height: auto; /* Adjusted height */\r\n}\r\n\r\n/* Dynamic Floating Logos */\r\n.twitter-logo,\r\n.instagram-logo,\r\n.tiktok-logo,\r\n.facebook-logo {\r\n    position: absolute;\r\n    width: 30px;\r\n    height: 30px;\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    animation: floatLeftToRight 8s linear infinite;\r\n    opacity: 0.8;\r\n    top: calc(10% + (80% * var(--random-y)));\r\n}\r\n\r\n/* Platform-Specific Logos */\r\n.twitter-logo {\r\n    background-image: url('/public/icons/x.png');\r\n}\r\n.instagram-logo {\r\n    background-image: url('/public/icons/instagram-logo.png');\r\n}\r\n.tiktok-logo {\r\n    background-image: url('/public/icons/tiktok-logo.png');\r\n}\r\n.facebook-logo {\r\n    background-image: url('/public/icons/facebook-logo.png');\r\n}\r\n\r\n/* Optional: Glowing Effect */\r\n.twitter-logo.glowing,\r\n.instagram-logo.glowing,\r\n.tiktok-logo.glowing,\r\n.facebook-logo.glowing {\r\n    animation: floatLeftToRight 10s linear infinite, glow 2s infinite alternate;\r\n}\r\n\r\n/* Glow Animation */\r\n@keyframes glow {\r\n    0% {\r\n        opacity: 0.6;\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n/* Platform Heading */\r\n.platform-heading {\r\n    position: absolute;\r\n    top: 5px;\r\n    left: 20px;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n    color: white;\r\n}\r\n\r\n/* Filters Layout */\r\n.filters {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\r\n    gap: 10px;\r\n    margin-top: 10px;\r\n}\r\n\r\n/* Action Buttons */\r\n.action-buttons {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.btn {\r\n    padding: 8px 16px;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s, opacity 0.3s;\r\n}\r\n\r\n.get-btn {\r\n    background-color: #28a745;\r\n    color: white;\r\n}\r\n\r\n.post-btn {\r\n    background-color: #007bff;\r\n    color: white;\r\n}\r\n\r\n.btn:hover {\r\n    opacity: 0.9;\r\n}\r\n\r\n.btn:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n\r\n\r\n/* Right-Side Platform Selection */\r\n.mention-platform-selection {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .mention-platform-checkbox {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n  }\r\n  \r\n  .short-input {\r\n    width: 120px; /* Shortened date input width */\r\n  }\r\n  \r\n\r\n  /* ANIMATIONS FOR COIN */\r\n  /* Mentions Action (Button + Coin) */\r\n.mentions-action-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin-top: 10px;\r\n}\r\n\r\n/* Coin Container */\r\n.mentions-coin-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n/* Coin Animation */\r\n/* Mentions Action (Button + Coin) */\r\n.mentions-action-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin-top: 10px;\r\n}\r\n\r\n/* Coin Container */\r\n.mentions-coin-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n/* Coin Animation */\r\n.mentions-coin {\r\n    width: 40px;\r\n    height: 40px;\r\n    display: none;\r\n}\r\n\r\n/* Mentions Count */\r\n/* .mentions-count {\r\n    font-size: 1.2rem;\r\n    font-weight: bold;\r\n    color: gold;\r\n    text-shadow: 1px 1px 3px black;\r\n} */\r\n\r\n/* Coin Type Selector */\r\n.coin-selector {\r\n    margin-top: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.coin-selector label {\r\n    font-size: 1rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.coin-selector select {\r\n    padding: 5px;\r\n    font-size: 1rem;\r\n    border-radius: 5px;\r\n}\r\n.mention-chart {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;  /* Ensures it takes full available width */\r\n  height: 400px; /* Increase height to prevent cut-off */\r\n  overflow: hidden;\r\n  margin-bottom: -35px;\r\n}\r\n\r\n.daily-mentions-container {\r\n  width: 90%; /* Use more space for the bar chart */\r\n  margin: auto; /* Center it */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.apexcharts-canvas {\r\n  max-width: 100% !important; /* Ensures charts resize properly */\r\n  height: auto !important;\r\n  margin-top: 60px\r\n}\r\n/* Mentions Action (Button + Coin Animation) */\r\n.mentions-action-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 15px;\r\n    margin-top: 15px;\r\n  }\r\n  \r\n  /* Mentions Counter */\r\n  .mentions-counter {\r\n    display: inline-flex;  /* Ensures it stays in a single line */\r\n    align-items: center;  /* Aligns text and any icons */\r\n    justify-content: center; /* Centers the text */\r\n    white-space: nowrap;  /* Prevents wrapping to the next line */\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    color: #1E3A8A; /* Deep blue text for a more elegant, professional feel */\r\n    text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3); /* Softer shadow for readability */\r\n    background-color: #F3F4F6; /* Light gray background for a clean, modern look */\r\n    border-radius: 10px; /* Rounded corners for a smooth look */\r\n    padding: 8px 16px; /* Padding for balance and ease */\r\n    border: 2px solid #F3F4F6; /* Border that matches the background for subtlety */\r\n    transition: all 0.3s ease; /* Smooth transition on hover */\r\n}\r\n\r\n\r\n\r\n  /* Coin Animation */\r\n  .mentions-coin {\r\n    width: 40px;\r\n    height: 40px;\r\n    animation: none; /* Initially no animation */\r\n    display: inline-block; /* Always visible */\r\n    margin-left: 8px;\r\n  }\r\n  \r\n  /* Add animation when triggered */\r\n  .mentions-coin.animate {\r\n    animation: coin-spin 1s ease-in-out infinite;\r\n  }\r\n  \r\n  @keyframes coin-spin {\r\n    0% {\r\n      transform: rotateY(0deg) scale(1);\r\n    }\r\n    50% {\r\n      transform: rotateY(180deg) scale(1.2);\r\n    }\r\n    100% {\r\n      transform: rotateY(360deg) scale(1);\r\n    }\r\n  }\r\n\r\n\r\n  .admin-panel-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    height: 100vh; /* Set full-page height */\r\n    overflow-y: auto; /* Enable scrolling for the whole page */\r\n}\r\n\r\n\r\n\r\n\r\n\r\n  .mentions-more-container {\r\n    width: 82.5%; /* Slightly increase width */\r\n    margin-left: 280px;\r\n    padding: 20px;\r\n    margin-top: 30px; /* More spacing from above */\r\n    background-color: #f8f9fa;\r\n    border-radius: 12px;\r\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);\r\n    text-align: center;\r\n    height: 40vh; /* Increase height */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n\r\n.bar-chart-wrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  margin-top: 20px;\r\n}\r\n\r\n\r\n.formatted-date {\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  color: #333; /* Change color as needed */\r\n  margin-left: 10px;\r\n  margin-top: 11px;\r\n  /* Add any other styling you need */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
